import { Typography } from '@design-system/components/typography/typography';
import { useState } from 'react';
import {
  faArrowCircleRight,
  faArrowCircleLeft,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';

export const ProfessionalCreatorSection = () => (
  <div className="flex flex-col gap-4">
    <div className="flex flex-col gap-2">
      <Typography variant="headline" size="medium">
        Become a professional creator
      </Typography>
      <Typography variant="body" size="large">
        This training takes you start to finish with becoming an online pro to
        scale your income
      </Typography>
    </div>
    <Carousel />
  </div>
);

const professionalCreatorArticles = [
  {
    to: 'https://help.playbookapp.io/en/collections/9688351-start-here',
    title: 'Start here',
    imgUrl: 'static/images/home/start-here.png',
  },
  {
    to: 'https://help.playbookapp.io/en/collections/9730963-set-your-offering',
    title: 'Set Your Offering',
    imgUrl: 'static/images/home/set-your-offering.png',
  },
  {
    to: 'https://help.playbookapp.io/en/collections/9730965-build-programs-workouts',
    title: 'Build Programs & Workouts',
    imgUrl: 'static/images/home/build-programs-and-workouts.png',
  },
  {
    to: 'https://help.playbookapp.io/en/collections/9730985-design-tips',
    title: 'Design Tips',
    imgUrl: 'static/images/home/design-tips.png',
  },
  {
    to: 'https://help.playbookapp.io/en/collections/9731039-marketing-best-practices',
    title: 'Marketing Best Practices',
    imgUrl: 'static/images/home/marketing-best-practices.png',
  },
  {
    to: 'https://help.playbookapp.io/en/collections/9731040-grow-and-retain-your-clients',
    title: 'Grow and Retain Clients',
    imgUrl: 'static/images/home/grow-and-retain-your-clients.png',
  },
];

const Carousel = () => {
  const [articles, setArticles] = useState(professionalCreatorArticles);
  const moveLeft = () =>
    setArticles([articles[articles.length - 1], ...articles.slice(0, -1)]);
  const moveRight = () => setArticles([...articles.slice(1), articles[0]]);

  return (
    <div className="flex items-center">
      <div
        onClick={moveLeft}
        className={clsx(
          'h-[202px] left-[0px] bg-red rounded-l-[10px] flex items-center px-2',
          sprinkles({ bg: 'W-100/50' }),
        )}
      >
        <FontAwesomeIcon icon={faArrowCircleLeft} className="text-[24px]" />
      </div>
      <div className="flex gap-4 items-center h-[208px] w-[1032px] overflow-x-hidden">
        {articles.map(({ to, title, imgUrl }) => (
          <a key={title} href={to} target="_blank" rel="noreferrer">
            <div
              className={clsx(
                'p-2 bg-white rounded-[10px] w-[246px] h-[202px] text-black text-center hover:shadow-design2',
              )}
            >
              <img src={import.meta.env.BASE_URL + imgUrl} />
              <Typography className="py-2" variant="body" size="large">
                {title}
              </Typography>
            </div>
          </a>
        ))}
      </div>
      <div
        onClick={moveRight}
        className={clsx(
          'h-[202px] right-[0px] bg-red rounded-r-[10px] flex items-center px-2',
          sprinkles({ bg: 'W-100/50' }),
        )}
      >
        <FontAwesomeIcon icon={faArrowCircleRight} className="text-[24px]" />
      </div>
    </div>
  );
};
